import { render, staticRenderFns } from "./ChatPic.vue?vue&type=template&id=77198ced&scoped=true"
import script from "./ChatPic.vue?vue&type=script&lang=js"
export * from "./ChatPic.vue?vue&type=script&lang=js"
import style0 from "./ChatPic.vue?vue&type=style&index=0&id=77198ced&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77198ced",
  null
  
)

export default component.exports